export enum TypographyVariants {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  TEXT16 = 'TEXT16',
  TEXT14 = 'TEXT14',
  TEXT10 = 'TEXT10',
}

export type TypographyVariantsType = keyof typeof TypographyVariants;
